/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { KeycloakService } from 'keycloak-angular';
import { EnvService } from 'src/app/env.service';

export function initializer(keycloak: KeycloakService): () => Promise<any> {
    const env = new EnvService();
    // Read environment variables from browser window
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__env'] || {};
    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    for (const key in browserWindowEnv) {
        if (browserWindowEnv.hasOwnProperty(key)) {
            env[key] = window['__env'][key];
        }
    }
    
    return (): Promise<any> => keycloak.init({
        config: {
            url: env['aaaUrl'], // 'azure
            // url: 'https://imt1-aaa.boschindia-mobilitysolutions.com/auth',
            realm: env['realm'],
            // realm: 'master',
            clientId: env['clientId'],
            // clientId: 'portal-app',
            'credentials': {
                'secret': env['clientSecret'] // azure
                // "secret": "bfe3fbb7-ce86-4392-be42-536dc1855b48"
            }
        },
        initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
        },
        enableBearerInterceptor: true,
        loadUserProfileAtStartUp: false,
        bearerExcludedUrls: ['/assets', '/clients/public', '/env.js']
    }).catch((err) => {
        console.log(err);
    });
}
